import * as React from 'react';
import Affix from '@telia-front/affix';
import { Table } from '@telia-front/table';
import MobileChannels from './mobile-channels';
import MobileServices from './mobile-services';
import MobileTableHeader from './mobile-table-header';
import MobileThemePackets from './mobile-theme-packets';
import MobileViewerSlots from './mobile-viewer-slots';
export default class MobileTable extends React.Component {
    constructor() {
        super(...arguments);
        this.headerTableRef = null;
        this.bodyTableRef = React.createRef();
        this.setHeaderTableRef = (el) => {
            this.headerTableRef = el;
        };
        /* istanbul ignore next */
        this.handleHeaderTableScroll = () => {
            if (this.bodyTableRef.current && this.headerTableRef) {
                this.bodyTableRef.current.scrollLeft = this.headerTableRef.scrollLeft;
            }
        };
        /* istanbul ignore next */
        this.handleBodyTableScroll = () => {
            if (this.bodyTableRef.current && this.headerTableRef) {
                this.headerTableRef.scrollLeft = this.bodyTableRef.current.scrollLeft;
            }
        };
        this.renderSection = (section) => {
            var _a, _b;
            switch (section.type) {
                case 'serviceGroups': {
                    const { type, data: serviceGroups } = section;
                    return serviceGroups && serviceGroups.services.length > 0 ? (React.createElement(MobileServices, { key: type, serviceGroups: serviceGroups, packets: this.props.packets, initialHeadingLevel: this.props.initialHeadingLevel })) : undefined;
                }
                case 'themePackets': {
                    const { type, data: themePackets } = section;
                    return themePackets && themePackets.packets.length > 0 ? (React.createElement(MobileThemePackets, { key: type, themePackets: themePackets, packets: this.props.packets, initialHeadingLevel: this.props.initialHeadingLevel })) : undefined;
                }
                case 'channels': {
                    const { type, data: channels } = section;
                    return channels && (channels.channels.length > 0 || !!((_b = (_a = channels.separatedChannels) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.length)) ? (React.createElement(MobileChannels, { key: type, channels: channels, packets: this.props.packets, initialHeadingLevel: this.props.initialHeadingLevel, showLanguages: this.props.showLanguages })) : undefined;
                }
                case 'viewerSlots': {
                    const { type, data: viewerSlots } = section;
                    return viewerSlots && viewerSlots.slots.length > 0 ? (React.createElement(MobileViewerSlots, { key: type, viewerSlots: viewerSlots, packets: this.props.packets, initialHeadingLevel: this.props.initialHeadingLevel })) : undefined;
                }
            }
        };
    }
    render() {
        const { sections, filter, packets } = this.props;
        const getPacketsProps = () => {
            return packets.map(packet => {
                if (packet.orderButton) {
                    packet.orderButton = Object.assign(Object.assign({}, packet.orderButton), { attributes: { tabIndex: -1 } });
                }
                return packet;
            });
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Affix, { "aria-hidden": true },
                React.createElement(Table, { bordered: true, elementRef: this.setHeaderTableRef, onScroll: this.handleHeaderTableScroll, minWidth: this.props.tableMinWidth, className: "tv-comparison__table" },
                    React.createElement("thead", null,
                        React.createElement(MobileTableHeader, { packets: getPacketsProps() })))),
            filter && React.createElement("div", { className: "tv-comparison__filter" }, filter),
            React.createElement("div", { className: "tv-comparison__body", ref: this.bodyTableRef, onScroll: this.handleBodyTableScroll },
                React.createElement("div", { style: this.props.tableMinWidth ? { minWidth: `${this.props.tableMinWidth}px` } : undefined }, sections.map(this.renderSection)))));
    }
}
